<script>
    import LySection from '../components/LySection.svelte';

    /**
     * @type {{
     *     padding?: boolean | string,
     *     border?: boolean | string,
     *     bg?: boolean | string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     label?: string | null,
     *     children?: import("svelte").Snippet,
     *     [key: string]: any,
     * }}
     */
    let { padding = true, border = true, bg = true, mt = 0, mb = 0, label = null, children, ...restProps } = $props();
</script>

<LySection {...restProps} tag="fieldset" {padding} {border} {bg} {mt} {mb} rounded={true}>
    {#if label}
        <legend
            class="pointer-events-none absolute -top-2 left-4 m-0 block rounded-sm border
                       border-(--dwc-border-color) bg-(--dwc-label-bg-color) bg-white px-2
                       py-1 text-sm leading-none font-bold">
            {label}
        </legend>
        <div class="relative block px-0 py-2"></div>
    {/if}

    {@render children?.()}
</LySection>
